<template>
	<div id="app">
		<Header/>
		<router-view/>
		<Footer/>
	</div>
</template>

<script>
import Header from './components/Common/Header'
import Footer from './components/Common/Footer'

export default {
  name: 'App',
	components: {
		Header,
		Footer
	},
}
</script>

<style lang="scss">
@import 'base/scss/mixin';
@import 'base/scss/reset';
@import 'base/scss/swiper.min';
body,html {
	max-width: 1920px;
	margin: 0 auto;
	overflow-x: hidden;
}
html {
	min-width: 1400px;
}
div[role="button"] {
  outline: none;
}
.insidebanner {
	position: relative;
	&-bor {
		position: absolute;
		left: 50%;
		width: 100%;
		height: 364px;
		margin-left: -50%;
		bottom: -190px;
		background: url(./assets/index/bor.png) center top no-repeat;
	}
	img {
		width: 100%;
	}
}
.content {
	position: relative;
	z-index: 2;
}
.cwidth {
	@extend %width;
}
.conttitle {
	text-align: center;
	font-size: 0;
	&-title {
		font-weight: normal;
		font-size: 28px;
		color: #1f4796;
	}
	&-bor {
		width: 70px;
		height: 2px;
		margin: 0 auto;
		background: #e8374a;
		display: block;
	}
}
.swiper-button-prev,
.swiper-button-next {
	width: 60px;
	height: 60px;
	background-size: 60px 60px;
}
.swiper-button-prev {
	background-image: url(./assets/index/leftbutton.png);
}
.swiper-button-next {
	background-image: url(./assets/index/rightbutton.png);
}

.swiper-pagination-bullet {
	width: 10px;
	height: 10px;
}
.swiper-pagination-bullet-active {
	opacity: .54;
	background: #000;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
	margin: 0 8px;
}
.province-select,
.city-select,
.district-select {
	float: left;
	position: relative;
	height: 60px;
	padding: 18px 0 18px 6px;
	background: #F1F1F1;
	border-radius: 4px;
	margin-right: 16px;
	position: relative;
	border: none;
	font-family: "黑体","SimHei";
	font-size: 16px;
	color: #999;
}
.province-select {
	width: 117px;
}
.city-select,
.district-select {
	width: 170px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue